const {ready} = cdm_blocks.fn;

( function($) {

    ready(function(){
        const tnsCarousel = document.querySelectorAll('.slider-wrapper');
        tnsCarousel.forEach(slider => {
            const tnsSlider = tns({
                container: slider,
                items: 1,
                autoplay: true,
                autoplayButtonOutput: false,
                nav: false,
				controlsText: ['<i class="fa-light fa-arrow-left"></i>', '<i class="fa-light fa-arrow-right"></i>'],
                lazyload: true,
                speed: 1000,
                mouseDrag: true,
                autoplayTimeout: 8000
            });
        });
    });


} )(jQuery);